
export default {
    namespaced: true,
    state: {
        data: {},
    },
    getters: {
        DATA: state => {
            return state.data;
        },
    },
    mutations: {
        DATA: (state, payload) => {
            return state.data = payload;
        },
    },
    actions: {
        SAVE: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/email-group',
                parameter: state.data,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                }
            });
        },
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/email-group',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let buf = {}
                    for (let key in responseData.data) {
                        buf[responseData.data[key].id] = responseData.data[key]
                    }

                    commit('DATA', buf);
                    payload.th.initData()
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }

    }
}